import type { Metadata } from "next";
import Link from "next/link";

export const metadata: Metadata = {
  title: "Page Not Found",
  description: "The page you're looking for doesn't exist. Browse our services, portfolio, or get in touch with Dev Cubix.",
  robots: {
    index: false,
    follow: true,
  },
};

export default function NotFound() {
  return (
    <div className="min-h-screen bg-surface flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-2xl bg-[#E11D24] flex items-center justify-center mx-auto mb-6">
          <span className="text-white font-bold text-2xl">404</span>
        </div>
        <h1 className="text-3xl font-bold text-foreground mb-3 font-ui">
          Page Not Found
        </h1>
        <p className="text-foreground/50 text-sm mb-8 font-body">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            href="/"
            className="px-6 py-3 bg-[#E11D24] text-white rounded-xl text-sm font-medium hover:brightness-110 transition-all"
          >
            Back to Home
          </Link>
          <Link
            href="/contact"
            className="px-6 py-3 border border-foreground/10 text-foreground rounded-xl text-sm font-medium hover:border-foreground/20 transition-all"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
